
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projekt Gemini',
	'appExit': 'Gå til velkomstsiden',


	'widgetsListLabel': 'Widgetliste. Vælg en widget, og tryk på Enter for at tilføje den.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Opdateret',
	'dirty': 'Ikke opdateret',
	'conflict': 'Konflikt ved lagring af oversigten',
	'error': 'Problem med lagring af oversigten',
	'failure': 'Kan ikke kontakte serveren',
	'saveFailed': 'Kan ikke gemme oversigten',

	'wa_insync': 'Gemt',
	'wa_conflict': 'Konflikt ved lagring af oversigten',
	'wa_error': 'Kan ikke gemme oversigten',
	'wa_failure': 'Kan ikke kontakte serveren',

	// Menu Labels
	'changeDisplay': 'Revidér fremvisning',
	'changeToColumnChart': 'Skift til kolonnediagram',
	'changeToBubbleChart': 'Skift til boblediagram',
	'toggleMoveHandles': 'Aktivér/deaktivér flyttehåndtag',
	'undo': 'Fortryd',
	'redo': 'Gentag',
	'mode': 'Skift tilstand',

	'untitled': 'Uden navn',
	'remove': 'Fjern',
	'editTitle': 'Redigér titlen',
	'edit': 'Redigér',
	'done': 'Udført',

	// Data tray
	'dataTrayHandleOpenLabel': 'Åbn databakke',
	'dataTrayHandleCloseLabel': 'Luk databakke',

	// Dialogs
	'dlg_loading': 'Indlæser...',
	'dlg_ok': 'OK',
	'dlg_create': 'Opret',
	'dlg_cancel': 'Annullér',
	'dlg_close': 'Luk',
	'dlg_update': 'Opdatér',
	'dlg_renameBoardTitle': 'Omdøb dette objekt',
	'dlg_renameDatasetTitle': 'Omdøb dette datasæt',
	'dlg_renameSceneTitle': 'Omdøb denne scene',
	'dlg_NameLabel': 'Navn:',
	'dlg_NewNameLabel': 'Nyt navn:',
	'dlg_DefaultNameWithDataSet': '%{name} - Oversigt',
	'dlg_ShareTitle': 'Del indhold',
	'dlg_UnshareTitle': 'Fjern indholdsdeling',
	'dlg_ShareUser': 'Bruger-id:',
	'dlg_NewColumnLabel': 'Nyt beregningsnavn',

	'dlg_new': 'Ny...',
	'dlg_open': 'Åbn...',
	'dlg_makeACopy': 'Opret en kopi',
	'dlg_rename': 'Omdøb...',
	'dlg_moreToCome': 'Flere handlinger, der er på vej...',

	'dlg_use': 'Brug',

	'dlg_RelinkDatasetTitle': 'Erstat datasæt \'%{datasetName}\' med ...',

	'open_error': 'Der er opstået et problem under åbning af oversigten.',

	// Delete Board
	'del_dialogTitle': 'Bekræft sletning',
	'del_itemMsg': 'Er du sikker på, at du vil slette \'%{name}\'?',
	'del_itemsMsg': 'Er du sikker på, at du vil slette %{count} elementer?',
	'del_deleteErr': 'Kan ikke slette \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'stigende',
	'dlg_descending': 'faldende',
	'dlg_custom': 'tilpasset',
	'dlg_none': 'ingen',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Søg',

	'searchHint': 'Søg i alle dine data',
	'clearSearchResult': 'Ryd søgeresultater',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Cirkel',
	'shapesHexagon': 'Sekskant',
	'shapesLine': 'Linje',
	'shapesOctagon': 'Ottekant',
	'shapesPentagon': 'Femkant',
	'shapesSquare': 'Kvadrat',
	'shapesTriangle': 'Trekant',
	'shapesDiamond': 'Rombe',
	'shapesTitle': 'Formegenskaber', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Afrundet kvadrat',
	'shapesStar': 'Stjerne',
	'shapesChevron': 'Vinkel',
	'shapesBadge_ribbon': 'Badgebånd',
	'shapesBadge': 'Badge',
	'shapesHeart': 'Hjerte',
	'shapesExclamation': 'Udråb',
	'shapesTrendingup': 'På vej op',
	'shapesTrendingdown': 'På vej ned',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Personer',
	'shapesFemale': 'Kvinde',
	'shapesHappyface': 'Glad ansigt',
	'shapesMale': 'Mand',
	'shapesMan': 'Mand',
	'shapesNeutralface': 'Neutralt ansigt',
	'shapesSadface': 'Trist ansigt',
	'shapesShakehands': 'Giv hånd',
	'shapesThumbsdown': 'Tommel ned',
	'shapesThumbsup': 'Tommel op',
	'shapesWoman': 'Kvinde',

	// Weather and places
	'shapesPlacesWeatherCat': 'Steder og vejr',
	'shapesCity': 'By',
	'shapesCloud': 'Sky',
	'shapesEducation': 'Uddannelse',
	'shapesGovernment': 'Myndighed',
	'shapesHalfcloud': 'Halv sky',
	'shapesHouse': 'Hus',
	'shapesMoon': 'Måne',
	'shapesRain': 'Regn',
	'shapesSunny': 'Solskin',

	//Vehicles
	'shapesVehiclesCat': 'Køretøjer',
	'shapesAirplane': 'Fly',
	'shapesCar': 'Bil',
	'shapesShip': 'Skib',
	'shapesShoppingcart': 'Indkøbsvogn',
	'shapesTrain': 'Tog',
	'shapesTruck': 'Lastbil',

	//Objects
	'shapesObjectsCat': 'Objekter',
	'shapesBook': 'Bog',
	'shapesBriefcase': 'Mappe',
	'shapesCalendar': 'Kalender',
	'shapesCheck': 'Check-',
	'shapesClock': 'Ur',
	'shapesDesktop': 'Computer',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Mad',
	'shapesGear': 'Tandhjul',
	'shapesHealth': 'Sundhed',

	'shapesIdea': 'Ide',
	'shapesMobile': 'Mobil',
	'shapesMoney_bill': 'Pengeseddel',
	'shapesMoney_coin': 'Mønt',
	'shapesPiggybank': 'Sparegris',
	'shapesStackofpaper': 'Papirstak',
	'shapesStickynote1': 'Huskeseddel 1',
	'shapesStickynote2': 'Huskeseddel 2',
	'shapesTarget': 'Mål',
	'shapesTool': 'Værktøj',

	'shapesUmbrella': 'Paraply',

	'shapesBrain': 'Hjerne',
	'shapesSkull': 'Kranie',
	'shapesEye': 'Øje',

	// Arrows shapes
	'shapesArrowsCat': 'Pile',
	'shapesRightArrow': 'Højre pil',
	'shapesLeftArrow': 'Venstre pil',
	'shapesDoubleArrow': 'Dobbeltpil',
	'shapesCurvedArrow': 'Buet pil',

	// Callouts shapes
	'shapesCalloutsCat': 'Forklaringer',
	'shapesRectCallout': 'Forklaring',

	// Images
	'imagesCat': 'Billeder',
	'imageWidgetTitle': 'Billedwidget',
	'imgUrl': 'Billed-URL',
	'noImgSelected': 'Intet billede er valgt',
	'enterImgUrl': 'Angiv billed-URL her',
	'imgPasteLink': 'Indsæt URL\'en, og tryk på Enter for at gemme den.',
	'imgResizeToFit': 'Tilpas størrelsen, så den passer til billedets størrelse',
	'imgHeight': 'Højde:',
	'imgWidth': 'Bredde:',
	'imgTransparency': 'Gennemsigtighed:',
	'imgMissingUrl': 'Billed-URL\'en mangler.',
	'imgUrlValidationError': 'Billed-URL\'en er ikke gyldig',
	'imgUrlInvalidDomainError': 'Billed-URL\'en peger på et domæne, som ikke er blevet godkendt af administratoren. De domæner, der er godkendt af administratoren, er "%{domains}".',

	// line shape
	'propStrokeWidth': 'Linjetykkelse',
	'propStrokeDashArray': 'Linjetype',
	'propStrokeSolidline': 'Ubrudt linje',
	'propStrokeLineCap': 'Linjeende',
	'propStrokeLineCapButt': '"Butt"',
	'propStrokeLineCapRound': 'Afrundet',
	'propStrokeLineCapSquare': 'Kvadrat',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Afspil',
	'dataPlayerValueListLabel': 'Dataafspilningsværdier',
	// Text Widget
	'textWidgetTitle': 'Tekstwidget',
	'textStyle': 'Typografier',
	'textStyleDescription': 'Forudformaterede teksttypografier',
	'textTitleStyle': 'Titel',
	'textTitleSmallStyle': 'Titel lille',
	'textSubtitleStyle': 'Undertitel',
	'textBodyStyle': 'Indhold',
	'textBodySmallStyle': 'Indhold lille',
	'textCaptionStyle': 'Overskrift',
	'textQuoteStyle': 'Citat',
	'textQuoteSmallStyle': 'Citat lille',
	'textResponsiveStyle': 'Automatisk størrelse',
	'textAutoFontSize': 'Automatisk',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Fin streg',
	'textFontFamilySubClassThin': 'Tynd',
	'textFontFamilySubClassThinItalic': 'Tynd kursiv',
	'textFontFamilySubClassExtraLight': 'Ekstra lys',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra lys kursiv',
	'textFontFamilySubClassLight': 'Lys',
	'textFontFamilySubClassLightItalic': 'Lys kursiv',
	'textFontFamilySubClassRegular': 'Almindelig',
	'textFontFamilySubClassRegularItalic': 'Almindelig kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium kursiv',
	'textFontFamilySubClassHeavy': 'Fed',
	'textFontFamilySubClassHeavyItalic': 'Fed kursiv',
	'textFontFamilySubClassDemiBold': 'Halvfed',
	'textFontFamilySubClassDemiBoldItalic': 'Halvfed kursiv',
	'textFontFamilySubClassBold': 'Fed',
	'textFontFamilySubClassBoldItalic': 'Fed kursiv',
	'textFontFamilySubClassExtraBold': 'Ekstra fed',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra fed kursiv',
	'textFontFamilySubClassBlack': 'Sort',
	'textFontFamilySubClassBlackItalic': 'Sort kursiv',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Automatisk fontstørrelse',
	'responsiveCoachmarkContents': 'Fontstørrelsen ændres automatisk, når du ændrer størrelse på denne teksttype. Du kan angive fontstørrelsen i tekstegenskaberne.',

	'propText': 'Tekstdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Tekstegenskaber', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Fontstørrelse',
	'textFontFamily': 'Fontserie',
	'textFontWeight': 'Fonttykkelse', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Billedlink',
	'propMissingURL': 'Indtast URL',
	'propImgTop': 'Billedegenskaber', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Generelle egenskaber', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Generelt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Generelt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Udfyldningsfarve', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Tekstfarve', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Kantfarve',
	'propMaintainAxisScales': 'Bevar akseskala',
	'propShowItemLabel': 'Vis elementetiketten',
	'propHideLegend': 'Skjul beskrivelsen',
	'propColorPalette': 'Palet',
	'propLegendPosition': 'Beskrivelsesposition',
	'propHideAxisTitleLabels': 'Skjul aksetitler',
	'propLineColor': 'Linjefarve',
	'propBubbleColor': 'Boblefarve',
	'propInterpolation': 'Bløde linjer',
	'propElementColor': 'Visualiseringselementfarve',
	'propSymbolShape': 'Symbolform',
	'propHeatScalePalette': 'Farverækkefølge',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Mørkere farver repræsenterer lavere værdier.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Mørkere farver repræsenterer højere værdier.',
	'propImageDetails': 'Billeddetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Detaljer om websider', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Detaljer om medier', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Angiv URL\'en, og tryk på Enter',

	//Layout Properties
	'sectionName_positionAndStyle': 'Placering og typografi',
	'propPositionLabel': 'Placering', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Størrelse', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Bredde',
	'propResizeHeight': 'Højde',
	'propRotateLabel': 'Rotér',
	'propRotateAngle': 'Vinkel', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Antal ikoner',
	'propScaleDescription': 'Vælg antal ikoner',
	'propScaleFew': 'Lav',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Høj',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Denne værdi skal være numerisk',

	'mediaAriaLabel': 'url-input',
	'dropdownAriaLabel' : 'Liste',
	'ariaGroupLabel': 'Listekategori: %{cateoryLabel} item: %{itemLabel}. Tryk på ned-tasten for at udvide. Navigér ved at trykke på op- og ned-tasterne, eller tryk på ESCAPE-tasten for at skjule.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Sidst opfrisket: for %{timeInterval} siden',
	'widgetTimer': 'Timer til widget',

	// Theme colors
	'transparent': 'Ingen farve',
	'white': 'Hvid',
	'lightGrey': 'Lys grå',
	'grey': 'Grå',
	'darkGrey': 'Mørk grå',
	'black': 'Sort',
	'lightBlue': 'Lys blå',
	'blue': 'Blå',
	'darkBlue': 'Mørk blå',
	'yellow': 'Gul',
	'orange': 'Orange',
	'lime': 'Limegrøn',
	'green': 'Grøn',
	'peach': 'Fersken',
	'red': 'Rød',
	'violet': 'Violet',
	'aqua': 'Akvamarin',
	'purple': 'Mørklilla',
	'plum': 'Mørkerød',
	'gray10': 'Grå 10',
	'gray20': 'Grå 20',
	'gray30': 'Grå 30',
	'gray50': 'Grå 50',
	'gray60': 'Grå 60',
	'gray70': 'Grå 70',
	'gray80': 'Grå 80',
	'gray90': 'Grå 90',
	'gray100': 'Grå 100',
	'blue50': 'Blå 50',
	'blue60': 'Blå 60',
	'blue70': 'Blå 70',
	'green40': 'Grøn 40',
	'green50': 'Grøn 50',
	'red50': 'Rød 50',
	'red60': 'Rød 60',


	//Theme Palette Label
	'paletteLabel': 'IBM-palet %{number}',
	'heatPaletteLabel': 'IBM-varmepalet %{number}',
	'conditionalPaletteLabel': 'IBM betinget palet %{number}',
	'carbonPaletteXLight': 'Carbon X - lys',
	'carbonPaletteXDark': 'Carbon X - mørk',
	'carbonPalettePurple': 'Mørklilla',
	'carbonPaletteTeal': 'Blågrøn',
	'carbonPaletteCyan': 'Cyan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Mørklilla blågrøn',
	'carbonPaletteCyanMagenta': 'Cyan magenta',
	'carbonPaletteGreenRed': 'Grøn Rød',
	'carbonPaletteGreenYellowRed': 'Grøn Gul Rød',
	'carbonPalettePurpleTealConvergent': 'Mørklilla blågrøn konvergent',
	'carbonPaletteCyanMagentaConvergent': 'Cyan Magenta konvergent',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM lys palet',
	'userPaletteColor_defaultTheme': 'IBM-standardpalet',
	'userPaletteColor_darkTheme': 'IBM mørk palet',

	// Dashboard
	'propDashboardBackgroundColor': 'Baggrundsfarve',
	'propLayoutPositioning': 'Layoutplacering',
	'propLayoutRelative': 'Relativ',
	'propLayoutAbsolute': 'Absolut',
	'propLayoutPositioningCoachmarkTitle': 'Vælg en layouttypografi',
	'propLayoutPositioningCoachmarkContent': 'I et relativt layout justeres størrelsen på og placeringen af widgetter til at kunne være på skærmen. Widgetter i et absolut layout vises præcist med den størrelse, du angiver, på den placering, hvor du indsætter dem i oversigten, uanset skærmstørrelse.',
	'gridText': 'Vis gitter',
	'snapText': 'Fastgør til gitter',
	'snapObjectsText': 'Fastgør til objekter',
	'fitPageText': 'Tilpas side',
	'gridLabel': 'Gitter',
	'heightUnit': 'h',
	'widthUnit': 'b',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Pakkestørrelse',
	'propPageSizePresetAriaLabel': 'Sidestørrelse forudangivet',
	'propPageSizePreset': 'Fast indstilling',
	'propPageSizePresetCustom': 'Tilpasset',
	'propPageSizePreset16x9': 'Skærmbillede 16:9',
	'propPageSizePreset4x3': 'Skærmbillede 4:3',
	'propPageSizePresetInfographic': 'Infografik',
	'propPageSizeWidth': 'Bredde',
	'propPageSizeHeight': 'Højde',
	'propPageSizeWidthAriaLabel': 'Bredde på sidestørrelse',
	'propPageSizeHeightAriaLabel': 'Højde på sidestørrelse',
	'propPageSizeAdjustedMessage': 'Sidestørrelsen er øget, fordi din indgang var under minimum eller ikke passer til dit dashboard.',
	'propTabShow': 'Vis skilleblade',
	'propShowTabsInPreview': 'Vis skilleblade i eksempel',
	'multilingualDashboardsLabel': 'Sprog',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Standard',
	'multilingualDashboardsAddLinkText': 'Tilføj et andet sprog',
	'multilingualDashboardsSelect': 'Vælg',
	'multilingualDashboardsButtonLabel': 'Tilføj',
	'multilingualDashboardTranslationMode': 'Du er nu i oversættelsestilstand (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Udført',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} oversættelser mangler',
	'multilingualDashboardRemainingString': '1 oversættelse mangler',
	'multilingualDashboardsSetDefault': 'Angiv standardsprog',
	'multilingualDashboardIconMore': 'Flere handlinger for sprog %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Område, der kan oversættes',
	'multilingualDeleteTitle': 'Slet sprog',
	'multilingualDeleteLanguageWarning': 'Er du sikker på, at du vil slette sproget \'%{language}\'?',
	'multilingualSelectLanguage': 'Vælg et sprog',
	'confirmLayoutStyleUpgradeTitle': 'Anvend på alle skilleblade',
	'confirmLayoutStyleUpgrade': 'Vil du anvende denne layouttype på alle skilleblade på dit dashboard?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Slet',
	'tabDeleteDialogTitle': 'Slet dette skilleblad?',
	'tabDeleteDialogMessage': 'Alt indhold på dette skilleblad bliver også slettet.',

	// Vis widget
	'propVisTypeReturn': 'Visualiseringstyper',
	'propVisDetails': 'Detaljer',

	// Alignment picker
	'propAlignPickTop': 'Justér til top',
	'propAlignPickRight': 'Justér til højre',
	'propAlignPickBottom': 'Justér til bund',
	'propAlignPickLeft': 'Justér til venstre',
	'propAlignPickCenter': 'Justér centreret',
	'propAlignPicker': 'Justering',

	// Toolbar picker
	'propToolbarPickBold': 'Fed',
	'propToolbarPickUnderline': 'Understreget',
	'propToolbarPickItalic': 'Kursiv',
	'propToolbarPickJustifyLeft': 'Justér til venstre',
	'propToolbarPickJustifyCenter': 'Justér centreret',
	'propToolbarPickJustifyRight': 'Justér til højre',
	'propToolbarPickJustify': 'Lige højremargen',

	'propList': 'Liste',
	'propOrderedList': 'Sorteret liste',
	'propUnorderedList': 'Usorteret liste',

	// Symbol shapes
	'propCircle': 'Cirkel',
	'propTriangle': 'Trekant',
	'propSquare': 'Kvadrat',
	'propRect': 'Rektangel',
	'propStar': 'Stjerne',
	'propCross': 'Kryds',
	'propPlus': 'Plus',
	'propPoly': 'Polygon',


	// True and false selection
	'propTrue': 'Sand',
	'propFalse': 'Falsk',

	// Position selection
	'propLeft': 'Venstre',
	'propRight': 'Højre',
	'propTop': 'Øverst',
	'propBottom': 'Nederst',

	// Interpolation options
	'propSmooth': 'Blød',
	'propStraight': 'Lige',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Liste', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Flyt til venstre', // screen reader
	'srWidgetMoveUp': 'Flyt op', // screen reader
	'srWidgetMoveRight': 'Flyt til højre', // screen reader
	'srWidgetMoveDown': 'Flyt ned', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Forøg størrelsen forholdsmæssigt', // screen reader
	'srWidgetResizeSmaller': 'Formindsk størrelsen forholdsmæssigt', // screen reader
	'srWidgetResizeBiggerV': 'Forøg størrelsen lodret', // screen reader
	'srWidgetResizeSmallerV': 'Formindsk størrelsen lodret', // screen reader
	'srWidgetResizeBiggerH': 'Forøg størrelsen vandret', // screen reader
	'srWidgetResizeSmallerH': 'Formindsk størrelsen vandret', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rotér med uret', // screen reader
	'srWidgetRotateCCW': 'Rotér mod uret', // screen reader

	// Recommended types
	'visChange': 'Skift visualisering',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisering',
	'chartLabel': '%{chartName} diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Tryk på F12 for at navigere i widgetten.',
	'f10KeyDescription': 'Tryk på F10 for at starte widgetfokus-fremvisningen',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} med værdien %{value}',

	'shapeColorLabel': 'Farve på form',
	'showLegendLabel': 'Vis beskrivelse',

	//Webpage
	'webpageWidgetTitle': 'Webside-widget',
	'webpagePasteLink': 'Indsæt URL\'en, og tryk på Enter for at gemme den.',
	'propWebpageLink': 'Webside-URL',
	'propWebpageTitle': 'Titel på webside',
	'propWebpageTitleDescription': 'Titel på websiden',
	'webpageUrl': 'Webside-URL',
	'noWebpageSelected': 'Ingen webside er valgt',
	'enterWebpageUrl': 'Angiv webside-URL her',
	'propWebpageTop': 'Egenskaber for webside', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Webside-URL\'en mangler.',
	'webpageUrlValidationError': 'Webside-URL\'en er ikke gyldig.',
	'webpageHttpValidationError': 'Websiden skal åbnes vha. et HTTPS-link.',
	'webpageInvalidDomainError': 'Webside-URL\'en peger på et domæne, som ikke er blevet godkendt af administratoren. De domæner, der er godkendt af administratoren, er "%{domains}".',

	//VizState
	'vzErrorLoading': 'Kan ikke indlæse visualisering',
	'vzErrorLoadingMissingData': 'Kan ikke indlæse visualisering. Kontekstdata mangler.',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Medie-widget',
	'mediaPasteLink': 'Indsæt URL\'en, og tryk på Enter for at gemme den.',
	'mediaUrl': 'Medie-URL',
	'noMediaSelected': 'Ingen medier valgt',
	'enterMediaUrl': 'Angiv medie-URL her',
	'videoHeight': 'Højde:',
	'videoWidth': 'Bredde:',
	'propMediaLink': 'Medielink',
	'propMediaTitle': 'Medietitel',
	'propMediaTitleDescription': 'Titel på mediet',
	'propMediaTop': 'Medieegenskaber', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Medielink-URL\'en mangler.',
	'mediaUrlValidationError': 'Mediefil-URL\'en er ikke gyldig.',
	'mediaUnknownValidationError': 'Denne type medie understøttes ikke.',
	'mediaHttpValidationError': 'Mediefilen skal åbnes vha. et HTTPS-link.',
	'mediaInvalidDomainError': 'Mediafil-URL\'en peger på et domæne, som ikke er blevet godkendt af administratoren. De domæner, der er godkendt af administratoren, er "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Egenskaber', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Datasæt',
	'dataViewsLabel': 'Vis',
	'columnQuality': 'Datakvalitet',
	'columnProperties': 'Dataegenskaber',

	'dataQuality': 'Datakvalitet',
	'dataQualityRowCount': 'Antal rækker',
	'dataQualityDistribution': 'Fordeling',
	'dataRowLabel': 'Data',

	// Modelling UI
	'typeColumn': 'Type',
	'modellingColumnType': 'Type',
	'modellingColumnAggregation': 'Aggregering',
	'modellingColumnUsage': 'Brug',
	'modellingColumnSort': 'Sortér',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Kategori',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Indlæser...',

	'modellingProcessing': 'Behandler...',
	'modellingImport': 'Importér',
	'modellingReimport': 'Importér igen',
	'modellingDatasourceTitle': 'Datakilde',
	'modellingImportStartedTitle': 'Import er startet',
	'modellingImportStartedText': 'Import af dine data kan tage et stykke tid. (Du kan oprette en oversigt, mens dataene importeres.)',
	'importDatasourceTitle': 'Forbindelser',
	'dropHere': 'Placér her for at oprette en ny datakilde...',
	'browseButton': 'Gennemse',
	'errorNoData': 'Der er ingen data at behandle.',
	'errorNoFile': 'Der er ingen fil at uploade.',
	'errorUploadFailed': 'Kan ikke uploade.',
	'uploadSucceessful': 'Upload er udført',
	'del_datasourceTitle': 'Slet datasæt',
	'del_datasourceMsg': 'Er du sikker på, at du vil slette \'%{name}\'?',
	'modellingFileUpdate': 'Opdatér',
	'modellingFileUpdateTitle': 'Opdatér datasæt',
	'modellingFileUpdateDescription': 'Vil du opdatere \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Opdaterer \'%{name}\'',
	'modellingUpdateStartedTitle': 'Opdateringsimport er startet',
	'modellingUpdateStartedText': 'Opdatering af dine data kan tage et stykke tid.\n\n(Du kan oprette en oversigt, mens dataene opdateres.)',
	'modellingErrorImportUploadNoFile': 'Der er ingen fil at uploade.',
	'modellingErrorImportUploadFailed': 'Kan ikke uploade.',
	'modellingErrorImportUploadInvalidType': 'Filtypen er ikke gyldig.',
	'modellingErrorImportUploadTableFailed': 'Kan ikke hente tabeller.',
	'modellingIntentResultsTitle': 'Vælg det foreslåede datasæt, som skal bruges',
	'modellingColumnViewRelationships': 'Vis relaterede tabeller',
	'modellingTableRelatedTables': 'Tabeller, der er relateret til \'%{name}\'',
	'modellingTable': '%{name} - Tabel',
	'modellingColumnIncludedInDataSet': 'Tilføjet',
	'modellingDataSet': 'Datasæt',
	'modellingViewInDataSet': 'Vis i datasæt',
	'modellingViewRelatedTables': 'Vis relaterede',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Ingen relaterede tabeller fundet',

	'modellingValidatingDataset': 'Validerer...',
	'datasetFinishedRefreshing': 'Datasættet %{datasetName} er opfrisket.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Opløs sammenkædningssti:',
	'modellingJoinColumns': 'Definér en sammenkædningssti for tabellen: %{name}',
	'modellingJoinToTable': 'Sammenkæd med tabellen: %{name}',

	// Data Quality
	'excluded': 'Udeladt',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtrér',
	'modellingColumnSortNone': 'Ryd sorteringen',
	'modellingColumnSortAsc': 'Sortér stigende',
	'modellingColumnSortDesc': 'Sortér faldende',
	'modellingColumnRemove': 'Fjern denne kolonne',

	// Import File Browser
	'dropboxPageTitle': 'Ny Dropbox-forbindelse',
	'sizeColumn': 'Størrelse',

	//Modelling Column Property Values
	'dataType_string': 'Streng',
	'dataType_date': 'Dato',
	'dataType_integer': 'Heltal',
	'dataType_double': 'Dobbelt',
	'dataType_float': 'Flydende',
	'dataType_boolean': 'Boolesk',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Antal',
	'defaultAggregation_countdistinct': 'Antal forskellige',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Gennemsnit',
	'defaultAggregation_sum': 'Sum',
	'defaultAggregation_auto': 'Automatisk (%{aggregationType})',

	'type_fact': 'Faktum',
	'type_attribute': 'Attribut',

	'defaultSort_none': 'Undlad at sortere',
	'defaultSort_asc': 'Sortér stigende',
	'defaultSort_desc': 'Sortér faldende',

	'category_none': 'Ingen',
	'category_location': 'Placering',
	'category_monetary': 'Monetær',
	'category_time': 'Tid',

	// Root menu
	'rootMenuTitle': 'Hovedmenu',

	'errorMessageTitle': 'Fejl',
	'errorMessageDetails': 'Detaljer: ',
	'errorMessageTitleAssetAlreadyExists': 'Aktiv findes allerede',

	'defaultTabTitle': 'Skilleblad %{index}',
	'tabAddBtnTitle': 'Tilføj et nyt skilleblad',

	'unsupportedConditionalFormattingEncountered': 'Betinget formatering anvendes ikke længere på visse kolonner.',


	// Homepage View
	'nameColumn': 'Navn',
	'creatorColumn': 'Oprettet af',
	'creationDateColumn': 'Dato for oprettelse',
	'versionColumn': 'Version',
	'modifiedColumn': 'Sidst ændret',

	'filterBy': 'Filtrér elementer',
	'allFilter': 'Alle elementer',
	'createdByMeFilter': 'Oprettet af mig',
	'sharedWithMeFilter': 'Delt med mig',
	'favoritesFilter': 'Mine favoritter',
	'recentsFilter': 'Tilføjet for nylig',
	'sortBy': 'Sortér efter',

	// Sort Menu
	'sortModified': 'Ændret',
	'sortUpdated': 'Opdateret',
	'sortName': 'Navn',

	'viewAs': 'Vis som',
	'thumbnailsView': 'Vis som miniaturer',
	'listView': 'Vis som en liste',
	'createMenu': 'Opret',
	'newAppItem': 'Dashboard',
	'newDataSet': 'Datasæt',

	'menuSelectionState_a11y': '"%{item}"-vælger er indstillet til "%{selectedItem}"',

	'unableToShareItem': 'Kan ikke dele elementet "%{item}".',
	'toastFetchingContent': 'Henter mere indhold...',
	'unableToGetData': 'Kan ikke hente indhold.',
	'unableToFavorite': 'Kan ikke ændre favoritstatussen.',
	'hpErrorMissingRequiredOptions': 'Mangler påkrævede initialiseringsindstillinger',
	'unableToOpenBoard': 'Kan ikke åbne "%{name}".',
	'unableToDuplicateBoard': 'Kan ikke duplikere "%{name}".',
	'unableToCreateBoard': 'Kan ikke oprette "%{name}".',
	'unableToCreateBoardNameConflict': 'Der findes allerede et aktiv med samme navn.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Rækker',
	'importWarnings': 'Advarsler',
	'lineNumbers': 'Linjer',
	'excerptFromSource': 'Uddrag',
	'reason': 'Årsag',
	'numberOfRowsDropped': 'rækker ignoreret',
	'oneRowDropped': '1 række blev ignoreret',

	// Type Menu
	'typeMenuLabel': 'Type',
	'dashboardsLabel': 'Dashboards',
	'datasetsLabel': 'Datasæt',
	'storiesLabel': 'Historier',
	'allLabel': 'Alle typer',

	// Board Page View App Bar
	'datasets': 'Datasæt',
	'settings': 'Egenskaber',
	'add': 'Tilføj',
	'widgets': 'Widgetter',
	'dashboardProperties': 'Dashboardegenskaber',
	'searchPanel' : 'Søg',
	'pins': 'Samling',
	'pinsOld': 'Mine tegnestifter',
	'pinsDateFilterHeading' : 'Dato fastgjort',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} tegnestift |||| %{smart_count} tegnestifter',
	'pinSearch': 'Søg',
	'pinSearchOld': 'Søg efter tegnestifter',
	'pinListView': 'Listeoversigt',
	'pinIconView': 'Ikonoversigt',
	'pinRemove': 'Fjern',
	'pinCreate': 'Opret',
	'pinDeleteError': 'Et eller flere aktiver kan ikke slettes fra samlingen. Prøv igen senere.',
	'pinDeleteErrorOld': 'En eller flere tegnestifter kan ikke slettes. Prøv igen senere.',
	'pinRetrieveError': 'En eller flere tegnestifter kan ikke hentes. Prøv igen senere.',
	'NoPinsCollected': 'Ingen fastgjorte visualiseringer',
	'pinDeletedToast': 'Tegnestift blev fjernet',
	'pinAddedToast': 'Tegnestiften blev føjet til Mine tegnestifter',
	'pinningToast': 'Behandler fastgørelse...',
	'pinDateFilter': 'Datofilter',
	'pinDateFilterAll': 'Alle',
	'pinDateFilterToday': 'I dag',
	'pinDateFilterYesterday': 'I går',
	'pinDateFilterPastWeek': 'Sidste uge',
	'pinDateFilterPastMonth': 'Sidste måned',
	'pinDateFilterEarlier': 'Tidligere',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Redigér titel',
	'toolbarActionSort': 'Sortér',
	'toolbarActionSortAscending': 'Sortér stigende',
	'toolbarActionSortDescending': 'Sortér faldende',
	'toolbarActionSortAuto': 'Automatisk (%{sortOrder})',
	'toolbarActionFormat': 'Dataformat',
	'toolbarActionFormatAbbreviation': 'Forkort',
	'toolbarActionFormatNone': 'Automatisk',
	'toolbarActionFilter': 'Filtrér',
	'toolbarActionTopBottom': 'Top eller bund',
	'toolbarActionAddShape': 'Tilføj form',
	'toolbarActionRmvShape': 'Fjern form',
	'toolbarActionToggleShapeDrop': 'Infografisk form',
	'toolbarActionToggleShapeDropTitle': 'Opret infografik',
	'toolbarActionToggleShapeDropText': 'Træk en form til dette felt for at oprette infografik.',
	'toolbarActionAggregationType': 'Opsummér',
	'toolbarDeleteActionText': 'Fjern kolonne',
	'toolbarActionFilterLocalKeepSelected': 'Bevar',
	'toolbarActionFilterLocalExcludeSelected': 'Udelad',
	'toolbarActionFilterAllKeepSelected': 'Filtrér',
	'toolbarActionSimpleCalculation': 'Enkel beregning',
	'toolbarActionDrillBack': 'Tilbage',
	'toolbarActionDrillUp': 'Drill-up',
	'toolbarActionDrillDown': 'Drill-down',
	'toolbarActionNavigate': 'Navigér',
	'toolbarActionCreateFilterGroup': 'Opret ny forbindelse',
	'toolbarActionDisconnectFilterGroup': 'Afbryd alle link',
	'toolbarActionLinkFilterGroup': 'Tilføj en eksisterende forbindelse',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Tilføj',
	'sidebarMultiselect': 'Aktivér/deaktivér flere valg',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} valgt',

	'multiselectWithTotalMsg': '%{count} af %{total}',
	'sidebarGoBack': 'Gå tilbage',

	//DataSet pane
	'errorLoadingDataSets': 'Dette datasæt kan ikke indlæses',
	'errorLoadingDataSetMetaData': 'Dette datasæt kan ikke indlæses',
	'dataSetPaneLastUpdated': 'Sidst opdateret: %{date}',
	'dataSetPaneDateUnknown': 'Ukendt',
	'sourcePaneLabel': 'Valgte kilder',
	'addSourceLabel': 'Tilføj en kilde',
	'find_label': 'Søg',
	'navigationPathsLabel': 'Navigationsstier',

	//widgetlist
	'errorLoadingWidgetList': 'Objekterne kan ikke indlæses.',
	'errorLoadingThemeFile': 'Temadefinitionen kan ikke indlæses',
	'errorLoadingLayoutFile': 'Oversigten kan ikke indlæses.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'De tilgængelige visualiseringsdefinitioner kan ikke indlæses',

	'dwErrorLoadingVisualizationNotFound': 'Objektet kan ikke indlæses, fordi det mangler en visualiseringsdefinition',
	'dwErrorLoadingVisualizationListNotFound': 'Visualiseringen kan ikke indlæses.',
	'dwErrorRunningQuery': 'Det er ikke muligt at hente data fra datasættet %{datasetName}.',
	'dwErrorGeoData': 'Det er ikke muligt at vise de geografiske data på et kort. Vælg en anden visualiseringstype. ',
	'dwPromptSignonCancelWarning': 'Dataene til denne visualisering er ikke tilgængelige. Brug de rigtige legitimationsoplysninger.',
	'dwErrorMissingDataset': 'Visualiseringen kan ikke indlæses, fordi det tilknyttede datasæt \'%{datasetName}\' ikke er tilgængeligt.',
	'dwErrorRenderingVisualization': 'Denne visualisering kan ikke indlæses.',
	'dwErrorVisualizationTooSmall': 'Visualiseringen er for lille til, at dens data kan vises. Gør visualiseringen større, eller begræns de indeholdte data.',
	'aria_label_datatable': 'Datatabel',
	'aria_key_navi_datatable_desc': 'Brug piltasterne til at navigere til hver enkelt celle. Tryk på Control- og Home-tasten for at flytte til første række og på Control- og End-tasten for at flytte til sidste række.',
	'geomapUnrecognizedLocations': 'Ukendte placeringer:',
	'geomapAmbiguousLocations': 'Uklare områder:',

	// custom widget
	'customWidget': 'Tilpasset widget',
	'customWidgetsTitle': 'Tilpassede widgetter',
	'noCustomWidgets': 'Ingen tilpassede widgetter',

	// Action names
	'toggleContextBar': 'Aktivér/deaktivér kontekstlinjen',
	'delete': 'Slet',
	'share': 'Del',
	'unshare': 'Ophæv deling',
	'rename': 'Omdøb',
	'close': 'Luk',
	'duplicate': 'Duplikér',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Prøv igen',

	'changeTemplate': 'Skift skabelon',

	// Aggregation Types
	'sum': 'Sum',
	'count': 'Antal',
	'countdistinct': 'Antal forskellige',
	'avg': 'Gennemsnit',
	'min': 'Minimum',
	'max': 'Maksimum',
	'custom': 'Tilpasset',
	'calculated': 'Beregnet',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': 'Ændringsprocent',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualiseringskriterier...',
	'QuickAddResultsHeader': 'Datavisualiseringer',
	'NoQuickAddResults': 'Der er intet, der matcher den angivne hensigt. Opret et nyt datasæt?',
	'NoQuickAddResultsRetry': 'Ingen forekomster blev fundet. Prøv igen med andre søgeord.',
	'templateWidgetTitle': 'Skabelon',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(tom)',

	'nullValueContent': '(ingen værdi)',
	'nullValueText': 'NULL',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Tekstfilter - %{columnName}',

	'textFilterSelectTab': 'Vælg',

	'textFilterConditionTab': 'Angiv en betingelse',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Der er ingen tilgængelige elementer.',

	'textFilterEquals': 'Er lig med',
	'textFilterContains': 'Indeholder',
	'textFilterBeginsWith': 'Begynder med',
	'textFilterEndsWith': 'Slutter med',
	'textFilterDoesNotEqual': 'Er ikke lig med',
	'textFilterDoesNotContain': 'Indeholder ikke',
	'textFilterDoesNotBeginWith': 'Begynder ikke med',
	'textFilterDoesNotEndWith': 'Slutter ikke med',
	'textFilterSampleText': 'Eksempel: A',

	'textFilterAndButton': 'Og',
	'textFilterOrButton': 'eller',

	'dateFilterMessage': 'Vælg et datointerval',
	'dateRangeControlRegionLabel': 'Datointervalfilter - %{columnName}',
	'dateFilterRangeOption': 'Intervalindstilling',
	'dateFilterDateLabel': 'Dato',
	'dateFilterBlank': '(tom)',
	'dateFilterBefore': 'Før',
	'dateFilterAfter': 'Efter',
	'dateFilterBetween': 'Mellem',
	'dateFilterSampleText': 'ÅÅÅÅ-MM-DD',
	'dateTitle': 'Dato',
	'dateIncludeBlankLabel': 'Inkludér tom dato',

	'timeTitle': 'Tid',
	'timeFilterMessage': 'Vælg et klokkeslætsinterval',
	'dateTimeFilterMessage': 'Vælg et dato- og klokkeslætsinterval',

	'topbottomNumberOfResultsLabel': 'Antal resultater',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Mellem %{lower}-%{higher}',
	'topbottomSelectOption': 'Øverste eller nederste - indstilling',
	'topbottomOptionLabel': 'Vis',
	'searchByLabel': 'Efter',
	'searchNoMatches': 'Ingen forekomster fundet',
	'topbottomRankColumnLabel': 'Tilføj en prioriteringskolonne til tabellen',
	'topbottomNone': 'Ingen',
	'topCount': 'Øverste antal',
	'topPercent': 'Øverste  %',
	'bottomCount': 'Nederste antal',
	'bottomPercent': 'Nederste  %',
	'topbottomSearchColumn': 'Søg efter en kolonne',
	'searchColumnAriaLabel': 'Søg efter en kolonne. Skriv navnet på den kolonne, du vil søge efter, og brug derefter pil ned til at finde kolonnen på listen.',
	'rankColumnLabel': 'Prioritet (%{columnLabel})',
	'topbottomClearLabel': 'Ryd',

	'rangeFilterControlRegionLabel': 'Intervalfilter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Skyderkontrol, brug højre og venstre pil til at flytte skyderhåndtagene',
	'sliderHandleLabel': 'Skyderhåndtag',
	'a11ySliderHandleLabel': 'Skyderhåndtag %{sliderValue}',
	'sliderInputLabel': 'værdi',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Nogle af de datasætelementer, der bruges i denne visualisering, er ikke tilgængelige.',
	'datasetItemUnavailable': 'Datasætelementet er ikke tilgængeligt',

	//Authoring topBottom
	'topOperator': 'Øverst',
	'bottomOperator': 'Nederst',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} efter %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Kun dette objekt',
	'deleteTopBottom': 'Slet antal for øverste eller nederste',
	'editTopBottom': 'Redigér antal for øverste eller nederste',
	'deleteDrillState': 'Slet aktuel drill-tilstand',
	'ariaDeleteDrillStateLabel': 'Tryk på ENTER for at redigere antal øverste eller nederste.',
	'drillUpStateTitle': 'Drill-up',
	'drillDownStateTitle': 'Drill-down',
	'ariaEditTopBottomLabel': 'Tryk på ENTER for at redigere antal øverste eller nederste.',
	'ariaDeleteTopBottomLabel': 'Tryk på DELETE for at slette antal øverste eller nederste.',

	// Authoring filtering
	'dimFilterIn': 'Inkluderer: %{in}',
	'dimFilterNotIn': 'Omfatter ikke: %{out}',
	'measureFilterBetween': 'Mellem %{lowerBound} og %{upperBound}',
	'measureFilterNotBetween': 'Ikke mellem %{lowerBound} og %{upperBound}',
	'gtFilter': 'Efter %{lowerBound}',
	'ltFilter': 'Før %{upperBound}',
	'notGtFilter': 'Ikke efter %{lowerBound}',
	'notLtFilter': 'Ikke før %{upperBound}',
	'localFilterTitle': 'Kun dette objekt',
	'globalFilterTitle': 'Alle objekter',
	'deleteFilter': 'Slet filter',
	'editFilter': 'Redigér filter',
	'ariaEditFilterLabel': 'Tryk på ENTER for at redigere filtret.',
	'ariaDeleteFilterLabel': 'Tryk på DELETE for at slette filtret.',

	// Prompts
	'ariaEditPrompt': 'Tryk på ENTER for at ændre promptværdien',

	'moreDataIndicator': 'Data blev afkortet ved %{threshold} elementer. Anvend et filter for at få vist færre.',

	// data point filtering
	'dataPointFilterTitle': 'Datapunkter',
	'dataPointFilterIncludeSummary': '%{valueCount} datapunkter er inkluderet',
	'dataPointFilterExcludeSummary': '%{valueCount} datapunkter er udeladt',

	// DB2 connection page
	'db2Database': 'DB2 Database (%{jdbcConnection})',
	'db2Title': 'Opret forbindelse til IBM DB2',

	// Database
	'databaseConnectionMessage': 'Angiv databaseforbindelsesdetaljer:',
	'connectionString': 'Databaseforbindelsesstreng',
	'databaseCredentials': 'Legitimationsoplysninger: ',
	'databaseUserName': 'Brugernavn',
	'databasePassword': 'Kodeord',
	'databaseConnect': 'Forbind',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Angiv et søgeord:',
	'twitterKeyword': 'Nøgleord',
	'twitterSearch': 'Søg',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Oversigten kan ikke oprettes: %{error}\nIkke-udført funktion: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Widget-filtre',
	'missingColumn': 'Mangler: %{columnLabel}',
	'missingFiltering': 'Manglende filtre på følgende kolonne-id\'er:',
	'heatByLabel': 'Varme efter',
	'evColumns': 'Kolonner',
	'evLocalFilters': 'Lokale filtre',
	'evExpand': 'Udvid',
	'evFilterTooltip': 'Filtrér',
	'evAdd': 'Tilføj en kolonne',

	// Navigation View
	'navigationBack': 'Tilbage',

	// Pinning
	'contentPinFail': 'Indholdet kan ikke indsamles. Prøv igen senere.',
	'contentPinFailOld': 'Indholdet kan ikke fastgøres. Prøv igen senere.',

	// Layouts
	'dropZoneLabel': 'Placér her for at maksimere',

	//Share
	'shareDefaultPageTitle': 'Side %{index}',

	'nextPage': 'Næste side',
	'previousPage': 'Forrige side',

	'assetAssembly': 'oversigt',

	'toolbar_save': 'Gem',
	'brgr_saveAs': 'Gem som',
	'brgr_refresh': 'Opfrisk',

	// Save
	'saving': 'Gemmer...',
	'save_success': 'Oversigten er gemt.',
	'save_failure': 'Desværre. Oversigten kunne ikke gemmes. Prøv igen senere.',
	'dashboard_save_success': 'Dit dashboard er gemt.',

	'geminiLeave': 'Du er ved at forlade IBM Watson Analytics.',

	'warning': 'Advarsel',
	'missingDataSetData': 'Data til dette datasæt er ikke tilgængelige. Opfrisk datasættet, eller kontakt administratoren for at få adgang til kilden.',

	// Calculations
	'error_calculation_in_use': 'Den valgte beregning er i brug og kan ikke slettes.',

	'resize': 'Tilpas størrelse',
	'rotate': 'Rotér',
	'moveHandle': 'Flyt widget',
	'expandHandle': 'Udvid',
	'panHandle': 'Panorér',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigér til',

	// Slide out titles
	'shapeSlideoutTitle': 'Former',
	'textSlideoutTitle': 'Tekst',
	'mediaSlideoutTitle': 'Medier',
	'visualizationSlideoutTitle': 'Visualiseringer',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Den angivne JSON er ugyldig. Der er flere oplysninger i logfilen.',

	// Widget type labels
	'shape_label': 'Form',
	'image_label': 'Billede',
	'data_label': 'Diagram',
	'media_label': 'Medier',
	'text_label': 'Tekst',
	'embedMedia_label': 'Medier',
	'youtube_label': 'YouTube-video',
	'webpage_label': 'Webside',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Form',
	'noExtraText_shape_numbered': 'Form (%{number})',
	'few_shape': 'Gruppe af %{count}-former',
	'many_shape': 'Gruppe af %{count}-former',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} billede',
	'one_image_numbered': '%{text} billede (%{number})',
	'noExtraText_image': 'Billede',
	'noExtraText_image_numbered': 'Billede (%{number})',
	'few_image': 'Gruppe af %{count}-billeder',
	'many_image': 'Gruppe af %{count}-billeder',
	'noExtraText_text': 'Tomt tekstfelt',
	'noExtraText_text_numbered': 'Tomt tekstfelt (%{number})',
	'few_text': 'Gruppe af %{count}-tekstfelter',
	'many_text': 'Gruppe af %{count}-tekstfelter',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube viewer',
	'pacubeviewer_named': '%{name} Cube viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} efter %{row_level1} og %{column_level1} krydstabel',
	'crosstab_opt_mapping_numbered': '%{values} efter %{row_level1} og %{column_level1} (%{number}) krydstabel',
	'crosstab_has_mapping': '%{values} efter %{row_level1} krydstabel',
	'crosstab_has_mapping_numbered': '%{values} efter %{row_level1} (%{number}) krydstabel',
	'crosstab_no_mapping': 'Tom krydstabel',
	'crosstab_no_mapping_numbered': 'Tom krydstabel (%{number})',
	'crosstab_named': '%{name} krydstabel',
	'crosstab_named_numbered': '%{name} krydstabel (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tabel',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tabel (%{number})',
	'JQGrid_no_mapping': 'Tom tabel',
	'JQGrid_no_mapping_numbered': 'Tom tabel (%{number})',
	'JQGrid_named': '%{name}-tabel',
	'JQGrid_named_numbered': '%{name} tabel (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1}-hierarki',
	'hierarchy_has_mapping_numbered': '%{level1} hierarki (%{number})',
	'hierarchy_no_mapping': 'Tomt hierarki',
	'hierarchy_no_mapping_numbered': 'Tomt hierarki (%{number})',
	'hierarchy_named': '%{name}-hierarki',
	'hierarchy_named_numbered': '%{name} hierarki (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories}-kort',
	'map_has_mapping_numbered': '%{categories} kort (%{number})',
	'map_no_mapping': 'Tomt kort',
	'map_no_mapping_numbered': 'Tomt kort (%{number})',
	'map_named': '%{name}-kort',
	'map_named_numbered': '%{name} kort (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual}-opsummeringsværdi',
	'summary_has_mapping_numbered': '%{actual} opsummeringsværdi (%{number})',
	'summary_no_mapping': 'Tom opsummeringsværdi',
	'summary_no_mapping_numbered': 'Tom opsummeringsværdi %{number})',
	'summary_named': '%{name}-opsummeringsværdi',
	'summary_named_numbered': '%{name} opsummeringsværdi (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} efter %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} efter %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Tom KPI',
	'kpi_no_mapping_numbered': 'Tom KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infografik',
	'infographicSummary_has_mapping_numbered': '%{actual} infografik (%{number})',
	'infographicSummary_no_mapping': 'Tom infografik',
	'infographicSummary_no_mapping_numbered': 'Tom infografik (%{number})',
	'infographicSummary_named': '%{name} infografik',
	'infographicSummary_named_numbered': '%{name} infografik (%{number})',
	'noExtraText_youtube': 'YouTube-video',
	'noExtraText_youtube_numbered': 'YouTube-video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube-video',
	'one_youtube_numbered': '%{text} YouTube-video (%{number})',
	'few_youtube': 'Gruppe af %{count}-YouTube-videoer',
	'many_youtube': 'Gruppe af %{count}-YouTube-videoer',
	'noExtraText_embedMedia': 'Medielink',
	'noExtraText_embedMedia_numbered': 'Medielink (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text}-medielink',
	'one_embedMedia_numbered': '%{text} medielink (%{number})',
	'few_embedMedia': 'Gruppe af %{count}-medielinks',
	'many_embedMedia': 'Gruppe af %{count}-medielinks',
	'noExtraText_media': 'Medier',
	'noExtraText_media_numbered': 'Medier (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text}-medier',
	'one_media_numbered': '%{text} medier (%{number})',
	'few_media': 'Gruppe af %{count}-medier',
	'many_media': 'Gruppe af %{count}-medier',
	'noExtraText_webpage': 'Webside',
	'noExtraText_webpage_numbered': 'Webside (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text}-webside',
	'one_webpage_numbered': '%{text} webside (%{number})',
	'few_webpage': 'Gruppe af %{count}-websider',
	'many_webpage': 'Gruppe af %{count}-websider',
	'one_unknown': 'Et objekt',
	'one_unknown_numbered': 'Et objekt (%{number})',
	'few_unknown': 'Gruppe af %{count}-objekter',
	'many_unknown': 'Gruppe af %{count}-objekter',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Næste',
	'previous': 'Forrige',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Aktuel navigationsgruppe er %{navigation_group_name}',

	//Page Context
	'filterBlank': '(tom)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Filterværdier kan ikke indlæses',
	'editTimelineHighlight': 'Redigér fremhævning',

	'filterDockChevronLeft': 'Blad gennem dataene',
	'filterDockChevronRight': 'Blad gennem dataene',
	'expand': 'Udvid',
	'collapse': 'Skjul',

	//Reset Dashboard
	'dashboardResetTitle': 'Nulstil dashboard',
	'dashboardResetMessage': 'Er du sikker på, at du vil nulstille anvendte ændringer til dette dashboard?',
	'dashboardResetToast': 'Dit dashboard er blevet nulstillet.',

	//Generate PDF
	'buildingPDF': 'Bygger PDF...',
	'exportPDF': 'Eksportér til PDF',
	'pageSize': 'Pakkestørrelse',
	'orientation': 'Retning',
	'filtersPresentPDF': 'Filter eller filtre, der er anvendt på visualiseringen eller visualiseringerne) på den foregående side:',
	'errorPDF': 'Kan ikke generere PDF. Opfrisk, og prøv igen.',
	'printPDFInfo': 'Vis dokumentation',
	'pdfWidget': 'Widget',
	'includeFilters': 'Vis filterdetaljer',
	'portrait': 'Højformat',
	'landscape': 'Tværformat',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Dit dashboard er blevet opgraderet. Gem nu for at bevare den optimale ydeevne.',

	'ariaFullScreenMessage': 'Tryk på Esc for at afslutte fuldskærm',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} pakket hierarkiboblediagram',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} pakket hierarkiboblediagram (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Tomt pakket hierarkiboblediagram',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Tomt pakket hierarkiboblediagram (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} pakket hierarkiboblediagram',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} pakket hierarkiboblediagram (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} efter %{values} marimekko-diagram',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} efter %{values} marimekko-diagram (%{number})',
	'LIVE_marimekko_no_mapping': 'Tomt marimekko-diagram',
	'LIVE_marimekko_no_mapping_numbered': 'Tomt marimekko-diagram (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko-diagram',
	'LIVE_marimekko_numbered': '%{name} marimekko-diagram (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} sunburst-diagram',
	'LIVE_sunburst_has_mapping_numbered': '%{values} sunburst-diagram (%{number})',
	'LIVE_sunburst_no_mapping': 'Tomt sunburst-diagram',
	'LIVE_sunburst_no_mapping_numbered': 'Tomt sunburst-diagram (%{number})',
	'LIVE_sunburst_named': '%{name} sunburst-diagram',
	'LIVE_sunburst_named_numbered': '%{name} sunburst-diagram (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values}-styreprogramsanalysediagram',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} styreprogramsanalysediagram (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Tomt styreprogramsanalysediagram',
	'LIVE_decision_analysis_no_mapping_numbered': 'Tomt styreprogramsanalysediagram (%{number})',
	'LIVE_decision_analysis_named': '%{name}-styreprogramsanalysediagram',
	'LIVE_decision_analysis_named_numbered': '%{name} styreprogramsanalysediagram (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} efter %{columnValue}- og %{lineValue}-linje- og kolonnediagram',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} efter %{columnValue} og%{lineValue}-linje- og kolonnediagram (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} og %{lineValue}-linje- og kolonnediagram',
	'LIVE_line_column_has_mapping_numbered': '%{categories} efter %{columnValue} og %{lineValue}-linje- og kolonnediagram (%{number})',
	'LIVE_line_column_no_mapping': 'Tomt linje- og kolonnediagram',
	'LIVE_line_column_no_mapping_numbered': 'Tomt linje- og kolonnediagram (%{number})',
	'LIVE_line_column_named': '%{name}-linje- og kolonnediagram',
	'LIVE_line_column_named_numbered' : '%{name} linje- og kolonnediagram (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} efter %{y} og %{size}-boblediagram',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} efter %{y} og %{size} boblediagram (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Tomt boblediagram',
	'LIVE_bubble_chart_no_mapping_numbered': 'Tomt boblediagram (%{number})',
	'LIVE_bubble_chart_named': '%{name}-boblediagram',
	'LIVE_bubble_chart_named_numbered': '%{name} boblediagram (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual}-punktopstillingsdiagram',
	'LIVE_bullet_has_mapping_numbered': '%{actual} punktopstillingsdiagram (%{number})',
	'LIVE_bullet_no_mapping': 'Tomt punktdiagram',
	'LIVE_bullet_no_mapping_numbered': 'Tomt punktopstillingsdiagram (%{number})',
	'LIVE_bullet_named': '%{name}-punktopstillingsdiagram',
	'LIVE_bullet_named_numbered': '%{name} punktopstillingsdiagram (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Data på dette dashboard leveres af',
	'showFooterToggleButtonText': 'Vis bundtekst',
	'showFooterSectionText': 'Bundtekst'
});
